// The code in this file will load on every page of your site
import wixLocation from 'wix-location';
$w.onReady(function () {

});

/**
*	Adds an event handler that runs when an item in a gallery is
 clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.Gallery.html#onItemClicked)
*	 @param {$w.GalleryItemClickedEvent} event
*/
export function gallery3_itemClicked(event) {
	console.log(event.item.description)
	wixLocation.to(event.item.description)
}